module.exports = __webpack_public_path__ + "media/corporate-image/tachikawalogo-e0d4cb6ee798d843e709688fe650af94.png";